export default "__VITE_ASSET__Hnrwo7sV__"